import { css } from 'linaria';

const root = css`
  position: relative;
`;

const container = css`
  overflow-x: hidden;
`;

const listWrapper = css`
  display: flex;
  transition: transform 0.3s ease-out;
  touch-action: pan-y;
`;

const itemWrapper = css`
  min-width: 100%;
`;

const footer = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  margin-top: var(--space-150);
`;

const footerMargin = css`
  margin-top: var(--space-200);

  @media (--from-tablet) {
    margin-top: var(--space-500);
  }
`;

const thumbs = css`
  width: 70px;
  overflow-x: hidden;
`;

const thumbsWrapper = css`
  display: flex;
  transition: transform 0.3s ease 0s;
`;
const thumb = css`
  width: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const thumbMargin = css`
  margin-right: var(--space-100);
`;

const thumbCircle = css`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--control-secondary);
  transition:
    transform 0.3s ease 0s,
    background-color 0.3s ease 0s;
`;

const thumbCircleActive = css`
  background-color: var(--control-accent);
`;

const thumbCircleSmall = css`
  transform: scale(0.7);
`;

const thumbCircleSmaller = css`
  transform: scale(0.4);
`;

const thumbTriangle = css`
  border-top: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-left: 5px solid var(--control-secondary);
  transition: transform 0.3s ease 0s;
`;

const thumbTriangleActive = css`
  border-left: 5px solid var(--control-primary);
`;

const thumbTriangleSmall = css`
  transform: scale(0.7);
`;

const thumbTriangleSmaller = css`
  transform: scale(0.4);
`;

const playVideo = css`
  position: absolute;
  top: 0;
  left: var(--space-200);

  @media (min-width: 768px) {
    left: var(--space-725);
  }
`;

const mobileGallerySsrSupport = css`
  display: block;
  @media (--from-desktop) {
    display: none;
  }
`;
const desktopGallerySsrSupport = css`
  display: none !important;
  @media (--from-desktop) {
    display: flex !important;
  }
`;

export {
  container,
  footer,
  footerMargin,
  itemWrapper,
  listWrapper,
  playVideo,
  root,
  thumb,
  thumbMargin,
  thumbCircle,
  thumbCircleActive,
  thumbCircleSmall,
  thumbCircleSmaller,
  thumbTriangle,
  thumbTriangleActive,
  thumbTriangleSmall,
  thumbTriangleSmaller,
  thumbs,
  thumbsWrapper,
  mobileGallerySsrSupport,
  desktopGallerySsrSupport,
};
